import { BACKEND_PRIVATE } from '@/api/base'

export async function sendApplication(payload: any) {
  return BACKEND_PRIVATE.post<void>('/me/vacancy/applications/create-as-freelancer', payload)
}

export async function sendApplicationAsCustomer(payload: any) {
  return BACKEND_PRIVATE.post<{ id: LX.VacancyApplication['id'] }>('/me/vacancy/applications/create-as-customer', payload)
}

export async function declineApplicationAsFreelancer(id: number) {
  return BACKEND_PRIVATE.post<void>(`/me/vacancy/applications/decline-as-freelancer?id=${id}`)
}

export async function declineApplicationAsCustomer(id: number) {
  return BACKEND_PRIVATE.post<void>(`/me/vacancy/applications/decline-as-customer?id=${id}`)
}

export async function readApplications(ids: number[]) {
  return BACKEND_PRIVATE.post<void>(`/me/vacancy/applications/mark-read`, null, { params: { ids } })
}

export async function getApplication(id: number) {
  return BACKEND_PRIVATE.get<LX.VacancyApplication>('/me/vacancy/applications/get', { params: { id } })
}

export async function applyApplication(id: number) {
  return BACKEND_PRIVATE.post<void>('/me/vacancy/applications/apply', null, { params: { id } })
}

export async function setInProgressApplication(id: number) {
  return BACKEND_PRIVATE.post<void>('/me/vacancy/applications/in-progress', null, { params: { id } })
}

export async function setApplicationMeta(id: number, meta: Record<string, boolean>) {
  return BACKEND_PRIVATE.post<void>('/me/vacancy/applications/upsert-tabs-meta', { id, meta })
}
